import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { PanicNavigationModels } from '../models/navigation.model';
import { AppState } from '../store/app.state';
import { selectVisibleNavigationItems } from '../store/state/permissions/permissions.selectors';

export function isNavigationItemActive(
  router: Router,
  item: PanicNavigationModels.ResolvedItem,
): boolean {
  return router.isActive(item.path, {
    paths: 'subset',
    queryParams: 'subset',
    fragment: 'ignored',
    matrixParams: 'ignored',
  });
}

export function injectVisibleNavigationItems(
  items: readonly PanicNavigationModels.ResolvedItem[],
): Signal<readonly PanicNavigationModels.ResolvedItem[]> {
  const store$ = inject(Store<AppState>);
  return toSignal(store$.select(selectVisibleNavigationItems(items)), {
    initialValue: [] as PanicNavigationModels.ResolvedItem[],
  });
}
